exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tickets-grid{display:grid;grid-template-columns:70% 30%;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.card-img{width:100px;height:35px}", "", {"version":3,"sources":["/var/www/html/cineco/website/vue-pwa-initial-setup/src/components/pages/paymentSummary.vue"],"names":[],"mappings":"AACA,cACE,aAAc,AACd,8BAA+B,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,UACE,YAAa,AACb,WAAa,CACd","file":"paymentSummary.vue","sourcesContent":["\n.tickets-grid {\n  display: grid;\n  grid-template-columns: 70% 30%;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.card-img {\n  width: 100px;\n  height: 35px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1df1930b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/pages/paymentSummary.vue
// module id = 1224
// module chunks = 5